export default {
  activeTimeZone: {
    notes: 'Text showing active timezone',
    message: 'Time zone: UTC{{offset}}',
  },
};
